<template>
  <div class="column is-10">
    <form method="post" @submit.prevent="submitData()">
      <div class="field">
        <label class="label">Name</label>
        <div class="control">
          <input type="text" :class="{'input': true, 'is-danger': errors.has('name')}" v-model="name">
        </div>
        <p class="help is-danger" v-show="errors.has('name')" v-text="errors.first('name')"></p>
      </div>
      <div class="field">
        <label class="label">Email</label>
        <div class="control">
          <input type="email" :class="{'input': true, 'is-danger': errors.has('email')}" v-model="email">
        </div>
        <p class="help is-danger" v-show="errors.has('email')" v-text="errors.first('email')"></p>
      </div>
      <div class="field">
        <label class="label">Phone</label>
        <div class="control">
          <the-mask :class="{'input': true, 'is-danger': errors.has('phone')}" v-model="phone" placeholder="Phone" mask="(###) ### ### ### ### ###"></the-mask>
        </div>
        <p class="help is-danger" v-show="errors.has('phone')" v-text="errors.first('phone')"></p>
      </div>
      <div class="field">
        <label class="label">Birth Place</label>
        <div class="control">
          <input type="text" :class="{'input': true, 'is-danger': errors.has('birth_place')}" v-model="birth_place">
        </div>
        <p class="help is-danger" v-show="errors.has('birth_place')" v-text="errors.first('birth_place')"></p>
      </div>
      <div class="field">
        <label class="label">Birthday</label>
        <div class="control">
          <input type="text" :class="{'input': true, 'is-danger': errors.has('birthday')}" v-model="birthday">
        </div>
        <p class="help is-danger" v-show="errors.has('birthday')" v-text="errors.first('birthday')"></p>
      </div>
      <div class="field">
        <label class="label">DATE</label>
        <div class="control">
          <input type="text" :class="{'input': true, 'is-danger': errors.has('date_group')}" v-model="date_group">
        </div>
        <p class="help is-danger" v-show="errors.has('date_group')" v-text="errors.first('date_group')"></p>
      </div>
      <div class="field">
        <label class="label">My Small Group Leader Role</label>
        <div class="control">
          <select :class="{'input': true, 'is-danger': errors.has('date_group_leader_role')}" v-model="date_group_leader_role">
            <option v-for="(leader_role_row, index) in leader_role_list" :key="index" :value="leader_role_row.id">{{leader_role_row.title}}</option>
          </select>
        </div>
        <p class="help is-danger" v-show="errors.has('date_group_leader_role')" v-text="errors.first('date_group_leader_role')"></p>
      </div>
      <div class="field">
        <label class="label">My Small Group Leader Name</label>
        <div class="control">
          <input type="text" :class="{'input': true, 'is-danger': errors.has('date_group_leader_name')}" v-model="date_group_leader_name">
        </div>
        <p class="help is-danger" v-show="errors.has('date_group_leader_name')" v-text="errors.first('date_group_leader_name')"></p>
      </div>
      <div class="field">
        <label class="label">My Small Group Leader Phone</label>
        <div class="control">
          <the-mask :class="{'input': true, 'is-danger': errors.has('date_group_leader_phone')}" v-model="date_group_leader_phone" placeholder="HDF/DF/DL Phone" mask="(###) ### ### ### ### ###"></the-mask>
        </div>
        <p class="help is-danger" v-show="errors.has('date_group_leader_phone')" v-text="errors.first('date_group_leader_phone')"></p>
      </div>
      <div class="field">
        <label class="label">My Small Group Leader Email</label>
        <div class="control">
          <input type="email" :class="{'input': true, 'is-danger': errors.has('date_group_leader_email')}" v-model="date_group_leader_email">
        </div>
        <p class="help is-danger" v-show="errors.has('date_group_leader_email')" v-text="errors.first('date_group_leader_email')"></p>
      </div>
      <div class="field">
        <label class="label">Previous Ministry</label>
        <div class="control">
          <select :class="{'input': true, 'is-danger': errors.has('previous_ministry')}" v-model="previous_ministry">
            <option v-for="(previous_ministry_row, index) in previous_ministry_list" :key="index" :value="previous_ministry_row.id">{{previous_ministry_row.title}}</option>
          </select>
        </div>
        <p class="help is-danger" v-show="errors.has('previous_ministry')" v-text="errors.first('previous_ministry')"></p>
      </div>
      <div class="field is-grouped">
        <div class="control">
          <button class="button is-link">Submit</button>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import {TheMask} from 'vue-the-mask'

export default {
  data () {
    return {
      name: '',
      email: '',
      phone: '',
      birth_place: '',
      birthday: '',
      date_group: '',
      date_group_leader_role: '',
      date_group_leader_name: '',
      date_group_leader_phone: '',
      date_group_leader_email: '',
      previous_ministry: '',
      leader_role_list: [],
      previous_ministry_list: []
    }
  },
  components: {
    TheMask
  },
  props: [
    'profileData'
  ],
  created () {
    this.getLeaderRole()
    this.getPreviousMinistry()

    this.name = this.profileData.name
    this.email = this.profileData.email
    this.phone = this.profileData.phone
    this.birth_place = this.profileData.birth_place
    this.birthday = this.profileData.birthday
    this.date_group = this.profileData.date_group
    this.date_group_leader_role = this.profileData.date_group_leader_role
    this.date_group_leader_name = this.profileData.date_group_leader_name
    this.date_group_leader_phone = this.profileData.date_group_leader_phone
    this.date_group_leader_email = this.profileData.date_group_leader_email
    this.previous_ministry = this.profileData.previous_ministry
  },
  watch: {
    profileData (value) {
      this.name = value.name
      this.email = value.email
      this.phone = value.phone
      this.birth_place = value.birth_place
      this.birthday = value.birthday
      this.date_group = value.date_group
      this.date_group_leader_role = value.date_group_leader_role
      this.date_group_leader_name = value.date_group_leader_name
      this.date_group_leader_phone = value.date_group_leader_phone
      this.date_group_leader_email = value.date_group_leader_email
      this.previous_ministry = value.previous_ministry
    }
  },
  methods: {
    getLeaderRole () {
      var self = this
      self.flyGet('member/date_leader_group_role')
      .then(function (response) {
        if (response.data.response_code === 1) {
          self.leader_role_list = response.data.data
          self.date_leader_group_role = self.leader_role_list[0].id
          self.errors.clear()
        } else {
          var result = response.data.message
          self.errors.clear()
          for (var name in response.data.message) {
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    getPreviousMinistry () {
      // this.$geb.emit({id: 'preloader', eventData: true})
      var self = this
      self.flyGet('member/previous_ministry')
      .then(function (response) {
        // self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          self.previous_ministry_list = response.data.data
          self.previous_ministry = self.previous_ministry_list[0].id
        } else {
          var result = response.data.message
          for (var name in response.data.message) {
            self.errors.remove(name)
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.errorMessage(response)
      })
    },
    submitData () {
      var self = this
      self.$geb.emit({id: 'preloader', eventData: true})
      self.flyPostSession('profile/update', {
        name: self.name,
        email: self.email,
        phone: self.phone,
        birth_place: self.birth_place,
        birthday: self.birthday,
        date_group: self.date_group,
        date_group_leader_role: self.date_group_leader_role,
        date_group_leader_name: self.date_group_leader_name,
        date_group_leader_phone: self.date_group_leader_phone,
        date_group_leader_email: self.date_group_leader_email,
        previous_ministry: self.previous_ministry
      })
      .then(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        if (response.data.response_code === 1) {
          alert('Update Profile Success!')
          self.$geb.emit({id: 'profile_section_event', eventData: 'profile'})
        } else {
          var result = response.data.message
          for (var name in response.data.message) {
            self.errors.remove(name)
            self.errors.add(name, result[name])
          }
        }
      })
      .catch(function (response) {
        self.$geb.emit({id: 'preloader', eventData: false})
        alert('System failure, please report to Connections Data Team. Thank you.')
        self.errorMessage(response)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>


// WEBPACK FOOTER //
// src/pages/panel/profile/components/ProfileUpdate.vue